import { render, staticRenderFns } from "./QuestionContent.vue?vue&type=template&id=c5f6324e&scoped=true&"
import script from "./QuestionContent.vue?vue&type=script&lang=js&"
export * from "./QuestionContent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionContent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./QuestionContent.vue?vue&type=style&index=1&id=c5f6324e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f6324e",
  null
  
)

export default component.exports